export default {
  title: 'Aplicações',
  fields: {
    id: 'ID',
    name: 'Nome',
    app_bundle_identifier: 'ID do Bundle da App',
    released: 'Lançada',
    franchise: 'Marca',
    app_icon: 'Ícone da App',
    status: 'Estado',
    play_store_link: 'Link da Play Store',
    apple_store_link: 'Link da Apple Store',
    dynamic_link: 'Link Dinâmico - Códigos QR',
  },
  filters: {
    name: 'Nome',
    released: 'Lançada',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Pronto para Construir',
    in_work: '🔧 Em Curso',
    in_review: '📝 Em Revisão',
    rejected: '❌ Rejeitada',
    released: '✅ Lançada',
    deactivated: '🛑 Desativada',
  },
  card: {
    overdue: 'Em atraso · {{time}}',
    copied: 'Copiado para a área de transferência',
    released_tag: {
      both: '✅ Lançada',
      ios: 'iOS Lançado',
      android: 'Android Lançado',
    },
    tags: {
      has_tech_issue: 'Problema técnico',
    },
  },
  status_modal: {
    title: 'Atualizar estado de lançamento',
    status_label: 'Estado',
    note_label: 'Nota (opcional)',
    note_placeholder: 'Adicione uma nota opcional para esta alteração de estado',
    tech_issue_checkbox: 'Existe um problema técnico',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  released: {
    yes: 'Sim',
    no: 'Não',
  },
  configured_status: {
    true: 'Sim',
    false: 'Não',
  },
  delete_confirmation: {
    title: 'Eliminar App Móvel',
    message: 'Tem a certeza que quer eliminar esta app móvel?',
    buttons: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
  },
};
